<template>
	<div class="event-speaker-card__speaker">
		<div @click="goToSpeaker" class="d-flex u-cursor-pointer">
			<Avatar
				class="event-speaker-card__speaker-avatar"
				:size="52"
				:avatar="speaker.speaker_logo"
			/>
			<div class="event-speaker-card__speaker-info">
				<p class="event-speaker-card__speaker-name">
					{{ speaker.speaker_name }}
				</p>
				<p class="event-speaker-card__speaker-title">
					{{ speaker.speaker_title }}
				</p>
				<p class="event-speaker-card__speaker-title">
					{{ speaker.speaker_company }}
				</p>
			</div>
		</div>
		<button @click="addToBookmark" type="button">
			<Icon
				:type="bookmarked ? 'bookmark' : 'bookmark_empty'"
				color="var(--button-icon-tint)"
				:size="24"
			/>
		</button>
	</div>
</template>
<script>
import Avatar from '@/components/Avatar'
import { mapActions, mapGetters } from 'vuex'

export default {
	data() {
		return {
			bookmarked: null,
		}
	},
	components: {
		Avatar,
	},
	props: {
		speaker: {
			type: Object,
			default: () => ({}),
		},
	},
	watch: {
		speaker: {
			handler() {
				this.bookmarked = this.speaker.bookmark.is_bookmarked
			},
			immediate: true,
		},
	},
	methods: {
		...mapActions('event', ['toggleBookmark']),
		async addToBookmark() {
			try {
				const prevStatus = this.bookmarked
				this.bookmarked = prevStatus === 1 ? 0 : 1
				await this.toggleBookmark({
					user_id: this.currentUser.user_id,
					bookmark_entity_type: this.speaker.bookmark.bookmark_entity_type,
					bookmark_status: this.bookmarked,
					bookmark_entity_id: this.speaker.bookmark.bookmark_entity_id,
				})
			} catch (e) {
				console.error(e)
				this.bookmarked = prevStatus
			}
		},
		goToSpeaker() {
			this.$router.push({
				name: 'speaker-by-id',
				params: { id: this.speaker.speaker_id },
			})
		},
	},
	computed: {
		...mapGetters('auth', ['profile']),
		currentUser() {
			return this.profile
		},
	},
}
</script>
<style lang="scss">
.event-speaker-card {
	&__speaker {
		display: flex;
		justify-content: space-between;
		background: #ffffff;
		align-items: center;
		padding: 12px;
		border: 1px solid #e2e2e2;
		border-radius: 12px;
		margin-bottom: 8px;
		text-decoration: none;

		&-avatar {
			margin-right: 12px;
			border-radius: 8px;
		}
		&-info {
			display: flex;
			width: 100% !important;
			flex-direction: column;
			min-height: 52px;
		}

		&-name {
			font-family: Inter, sans-serif;
			font-weight: 700;
			font-size: 16px;
			line-height: 100%;
			letter-spacing: 0;
			margin-bottom: 4px !important;
			color: var(--username-category-title);
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 1;
			-webkit-box-orient: vertical;
		}
		&-title {
			font-family: Inter, sans-serif;
			font-weight: 400;
			font-size: 13px;
			line-height: 100%;
			letter-spacing: 0;
			color: var(--company-position-large);
			margin-top: 2px;
		}

		&-icon {
			color: #9b9b9b !important;
		}
	}
}
</style>
